import { PromotionData, PromotionLogic, IMultiSetsMulticampaignPromotionInterface } from '@gongxigames/framework/promotions';

export class MultiSetsMulticampaignPromotionLogic extends PromotionLogic<IMultiSetsMulticampaignPromotionInterface> {
    public accept(succeessCB: () => void, failureCB: () => void = () => {}): void {
        this.promotionInterface.setChoice('accept', succeessCB, failureCB);
    }

    public reject(succeessCB: () => void, failureCB: () => void = () => {}): void {
        this.promotionInterface.setChoice('ask_me_later', succeessCB, failureCB);
    }

    public decline(succeessCB: () => void, failureCB: () => void = () => {}): void {
        this.promotionInterface.setChoice('decline', succeessCB, failureCB);
    }

    public end(): void {
        this.promotionInterface.end();
    }

    public endExpiredRounds(): void {
        this.promotionInterface.endExpiredRounds();
    }

    public getData(): PromotionData {
        return {
            rulesUrl: this.promotionInterface.getRulesUrl?.(),
            expirationTime: this.promotionInterface.getExpirationTime?.(),
            ...super.getData(),
        };
    }
}
